import { inject } from '@angular/core';
import { MarketplaceButtonAction, MarketplaceButtonActionPayload } from './marketplace-button.action';
import { createMarketplaceCartItem, MemberQuery, CheckoutService } from '@fgb/core';
import { Router } from '@angular/router';

/**
 * Action for merchant button in marketplace details. This action will clear the cart, add the selected item with attributes and quantity to the cart, and navigate the user to the checkout page.
 */
export class MerchantButtonAction extends MarketplaceButtonAction {
  invoke(payload: MarketplaceButtonActionPayload): void {
    const checkoutService = inject(CheckoutService);
    const memberQuery = inject(MemberQuery);
    const router = inject(Router);
    const { item, attribute, quantity, customFields } = payload;

    const memberId = memberQuery.getUserContext().memberId;
    // Checkout single item to cart and navigate to checkout page
    checkoutService.checkOutItems([createMarketplaceCartItem(item, quantity, memberId, attribute, customFields)]);
    router.navigate(['/payment/checkout']);
  }
}
